import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { ClinicalDataTabBase } from '@features/components/ClinicalData';
import { getLogItems } from '@features/components/ClinicalData/components/ClinicalLog';
import { getColorsByOrganType, isCaseTrial, isRandomizationScs } from '@/utils/helpers';
import { Case } from '@/api/apis/case';
import { ChatViewPermissions } from '@/permissions';

type ClinicalDataTabProps = {
  caseInfo: Case;
};

export const ClinicalDataTab = ({ caseInfo }: ClinicalDataTabProps) => {
  const { checkPermission } = useContext(AuthContext);
  const { organType, donorType, clinicalData, status, trialProgram, questionnaire, randomization } = caseInfo;

  const hasChatPermission = checkPermission(ChatViewPermissions.ViewChat);
  const colors = getColorsByOrganType(organType);
  const isTrialCase = isCaseTrial(organType, trialProgram, questionnaire);
  const isScs = isRandomizationScs(randomization);
  const clinicalDataItems = getLogItems(clinicalData, isTrialCase);

  return (
    <ClinicalDataTabBase
      donorType={donorType}
      status={status}
      organType={organType}
      clinicalData={clinicalData}
      isTrialCase={isTrialCase}
      clinicalDataItems={clinicalDataItems}
      sectionColor={colors.bg40}
      hasChatPermission={hasChatPermission}
      isScs={isScs}
    />
  );
};
